import { combineReducers, rm } from 'utils';
import { BaseAction, BaseInitialState, BaseState, baseFormReducer, baseReducer } from '../../Utils';
import {
  BaseZendeskFormAction,
  BaseZendeskFormState,
  Options,
  ZendeskWithProductsInitialState,
  addProductsReducer,
  baseZendeskFormReducer,
  validateProducts,
  validateQuestion,
  validateSubject
} from '../utils';

export const orderManagementFormId = 29744508172818;
export const subjectFieldId = '29605689036562';
export const reasonFieldId = '29746793483538';
const ORDER_CANCELLATION_SUBJECT_ID = 1;

type InternalState = BaseState & BaseZendeskFormState;

export const orderManagementInitialState: InternalState = {
  ...BaseInitialState,
  ...ZendeskWithProductsInitialState,
  showReason: false
};

type Action = BaseAction | BaseZendeskFormAction;

const orderManagementReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'showReason':
      return { ...state, showReason: showReason(action.value) };

    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  orderManagementReducer,
  baseZendeskFormReducer,
  addProductsReducer
);

const showReason = (subject: number) => {
  return subject === ORDER_CANCELLATION_SUBJECT_ID;
};

type ValidatedState = Omit<InternalState, 'subject' | 'products'> &
  Required<Pick<InternalState, 'subject' | 'products'>>;

export const isValid = (
  state: InternalState,
  dispatch: (action: Action) => void
): state is ValidatedState => {
  const isValidSubject = validateSubject(state, dispatch);
  const isValidQuestion = validateQuestion(state, dispatch);
  const isValidProducts = validateProducts(state, dispatch);

  const isInvalidReason =
    state.subject === ORDER_CANCELLATION_SUBJECT_ID && state.reason === undefined;

  if (isInvalidReason) {
    dispatch({
      type: 'reasonError',
      value: rm(
        'customerservice_shared_error_general_part',
        rm('customerservice_zendesk_reason').toLowerCase()
      )
    });
  }

  return isValidSubject && isValidQuestion && isValidProducts && !isInvalidReason;
};

export const getSubjectOptions = (): Options[] => {
  return [
    { id: 1, tag: 'om_order_cancellation' },
    { id: 2, tag: 'om_order_change' },
    { id: 3, tag: 'om_order_handling' },
    { id: 4, tag: 'om_order_documentation' },
    { id: 5, tag: 'om_my_pages_customer_information' }
  ];
};

export const getReasonOptions = (): Options[] => {
  return [
    { id: 6, tag: 'om_no_longer_needed' },
    { id: 7, tag: 'om_ordered_wrong_item' },
    { id: 8, tag: 'om_better_price_available' },
    { id: 9, tag: 'om_delayed_delivery' },
    { id: 10, tag: 'om_other' }
  ];
};
